import React, { useState } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    summary: "Summary",
    name: "Name:",
    company: "Company:",
    email: "Email:",
    continue: "Continue",
    retype: "Retype",
    enterData: "Please enter data.",
  },
  ja: {
    summary: "概要",
    name: "名前:",
    company: "会社名:",
    email: "メール:",
    continue: "続ける",
    retype: "再入力",
    enterData: "データを入力してください。",
  },
  es: {
    summary: "Resumen",
    name: "Nombre:",
    company: "Empresa:",
    email: "Correo electrónico:",
    continue: "Continuar",
    retype: "Vuelva a escribir",
    enterData: "Por favor, ingrese los datos.",
  },
});

const Review = (props) => {
  const [clicked, setClicked] = useState(false);

  const buttonStyle = {
    width: "225px",
    height: "40px",
    marginTop: "10px",
    backgroundColor: "#FFC500",
    color: "black",
    borderRadius: "25px",
    textAlign: "center",
    padding: "10px 0",
    cursor: "pointer",
    transition: "background-color 0.3s",
    border: "none",
  };
  const inputStyle2 = {
    width: "50%",
    height: "100px",
    color: "black",
    borderRadius: "10px",
    padding: "10px",
    border: "1px solid #ccc",
  };

  const buttonHoverStyle = {
    color: "white",
    backgroundColor: "#EF6C00",
  };

  const handleContinueClick = () => {
    setClicked(true);
    props.triggerNextStep({ trigger: "not_login_4" });
  };

  const handleRetypeClick = () => {
    setClicked(true);
    props.triggerNextStep({ trigger: "not_login_2" });
  };

  const userDataStep = props.steps["not_login_2"];

  if (userDataStep && userDataStep.value) {
    const { name, company, email } = userDataStep.value;

    if (name && company && email) {
      return (
        <div>
          <div style={{ width: "100%", textAlign: "center" }}>
            <h3 style={{ verticalAlign: "middle", marginBottom: "15px" }}>
              {localizationStrings.summary}
            </h3>
            <table>
              <tbody>
                <tr>
                  <td style={{ verticalAlign: "middle" }}>
                    ====================
                    <br />
                    <div style={{ margin: "10px 0" }} />
                    <strong>{localizationStrings.name}</strong>
                    <br />
                    <div style={{ margin: "10px 0" }} />
                    <div>{name}</div>
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "middle" }}>
                    ====================
                    <br />
                    <div style={{ margin: "10px 0" }} />
                    <strong>{localizationStrings.company}</strong>
                    <br />
                    <div style={{ margin: "10px 0" }}>{company}</div>
                    ====================
                    <br />
                  </td>
                </tr>
                <tr>
                  <td style={{ verticalAlign: "middle" }}>
                    <strong>{localizationStrings.email}</strong>
                    <br />
                    <div style={{ margin: "10px 0" }}>{email}</div>
                    ====================
                    <br />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button
            style={{
              ...buttonStyle,
              ...(clicked && buttonHoverStyle),
            }}
            onClick={handleContinueClick}
            disabled={clicked}
          >
            {localizationStrings.continue}
          </button>
          <button
            style={{
              ...buttonStyle,
              ...(clicked && buttonHoverStyle),
            }}
            onClick={handleRetypeClick}
            disabled={clicked}
          >
            {localizationStrings.retype}
          </button>
        </div>
      );
    }
  }

  return <div>{localizationStrings.enterData}</div>;
};

export default Review;
